import { render, staticRenderFns } from "./WebDraftLayout.vue?vue&type=template&id=8fbacdae&"
import script from "./WebDraftLayout.vue?vue&type=script&lang=js&"
export * from "./WebDraftLayout.vue?vue&type=script&lang=js&"
import style0 from "./WebDraftLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports